import { render, staticRenderFns } from "./BasePreloader.vue?vue&type=template&id=df24fb02"
import script from "./BasePreloader.vue?vue&type=script&lang=ts"
export * from "./BasePreloader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports